import { LeaveTypeCodes } from '@Enum/index';
import { Balance } from '@Types/api/form/leaveRequest/Balance';
import { parseDateTime } from '@Utils/transformDateTime';

export const getReimbursementTicketHint = (
  isAnnualLeave: boolean,
  startDate: string,
  balance: Balance
): string => {
  if (!isAnnualLeave || !startDate) {
    return 'To get an air ticket, apply for annual leave with at least 7 days and 1 eligible ticket';
  }

  const output = `As on ${parseDateTime(startDate)} Available ticket ${balance.ticketBalance} and Eligible ticket ${balance.eligibleTickets}`;
  return output;
};

export const getStartDateHint = (
  leaveTypeID: string,
  startDate: string,
  balance: Balance
): string => {
  const isAnnualLeave = Number(leaveTypeID) === LeaveTypeCodes.ANNUAL_LEAVE;
  const isEmergencyLeave =
    Number(leaveTypeID) === LeaveTypeCodes.EMERGENCY_LEAVE;
  const isTypeMatched = isEmergencyLeave || isAnnualLeave;

  if (!isTypeMatched || !startDate) {
    return '';
  }

  const output = `As on ${parseDateTime(startDate)} your leave balance is ${balance.asOnDate} days.`;
  return output;
};
